export default __webpack_public_path__ + "static/flowerpendantandropering-7230c9d85c2003290a93847d6efca580.png";